import React from "react";
import "./Cards.css";

// A contact, on the project Contacts tab.
const ContactCard = (props) => {
  return (
    <div>
      <div className="ContactCard my-3 mr-2">
        <div className="d-flex flex-row justify-content-between">
          <div>
            <p className="font-weight-normal m-0">
              {props.data.con_first_name} {props.data.con_last_name}
            </p>
            <small className="text-muted">{props.data.pc_relationship ? props.data.pc_relationship : (props.data.con_contact_type ?? '-')}</small>
          </div>
          <div>
            {props.contactTab && (
              <span>
                <i
                  onClick={() => {
                    props.onSelect(props.data.con_id);
                  }}
                  className="fas fa-info-circle px-2"
                ></i>
              </span>
            )}
            <span>
              <i
                onClick={() => props.onDel(props.data.con_id)}
                className="fas fa-trash"
                style={{ cursor: "pointer" }}
              ></i>
            </span>
          </div>
        </div>
        <hr className="HorizontalLine"></hr>
        <div className="d-flex flex-column">
          <span style={{ color: "rgba(0,0,0,0.6)" }}>
            <i className="fas fa-phone px-2"></i> {props.data.con_phone}
          </span>
          <span style={{ color: "rgba(0,0,0,0.6)" }}>
            <i className="fas fa-map-marker-alt px-2"></i> {props.data.con_Addr_line1}, {props.data.con_Addr_line2}, {props.data.con_city}, {props.data.con_state}, {props.data.con_zip}
          </span>
          <span style={{ color: "rgba(0,0,0,0.6)" }}>
            <i className="fas fa-user-friends px-1"></i> {props.data.pc_relationship ? props.data.pc_relationship : (props.data.con_contact_type ?? '-')}
          </span>
          <span style={{ color: "rgba(0,0,0,0.6)", marginTop: "0.5rem", whiteSpace: "pre-wrap" }}>
            <i className="fas fa-sticky-note px-2"></i> {props.data.con_note || '-'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ContactCard;
